module.exports = __webpack_public_path__ + "img/career-readiness-cover.7909e45d.jpg";